import Firma from '@/components/Firma.vue';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainReporteEstimacionesRelacionConceptos',
  components: {
    Firma,
  },
  mixins: [mixGenerarPdf, mixFormatoEstructura],
  data() {
    return {};
  },
  methods: {
    sumaImporteContratado(estimado) {
      const importes = estimado.map((est) => ({
        importe: est.concepto.importe,
      }));
      return this.$ObjSumar(importes, 'importe');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfCheckList(estaEstimacion, contratoEstimacion) {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${estaEstimacion.fechaPresentacion} 00:00:0`, []);

      let contrato = {
        numero: contratoEstimacion.numero,
        objeto: contratoEstimacion.meta,
        contratista: contratoEstimacion.contratista,
        fecha: contratoEstimacion.fecha,
        fechaInicio: contratoEstimacion.fechaInicio,
        fechaTermino: contratoEstimacion.fechaTermino,
        importe: contratoEstimacion.importe,
      };
      let estimacion = {
        numero: estaEstimacion.numero,
        fechaDel: estaEstimacion.fechaDel,
        fechaAl: estaEstimacion.fechaAl,
        fechaPresentacion: estaEstimacion.fechaPresentacion,
        fechaAutorizacion: estaEstimacion.fechaAutorizacion,

      };
      estimacion = this.formatoObjeto(estimacion);
      contrato = this.formatoObjeto(contrato);
      const fechaActual = this.formatoFechaActual();

      const nombreTemplate = 'templateCheckListDocumentacion';
      const listaDocumentos = [
        { documento: 'FACTURA FIRMADA (ARCHIVO PDF)', seccion: 1, orden: 1001 },
        { documento: 'FACTURA (ARCHIVO XML)', seccion: 1, orden: 1002 },
        { documento: 'VERIFICACIÓN DEL CFDI', seccion: 1, orden: 1003 },
        { documento: 'CONTROL DE ESTIMACIONES', seccion: 1, orden: 1004 },
        { documento: 'ESTIMACIÓN CONCENTRADO', seccion: 1, orden: 1005 },
        { documento: 'RELACIÓN DE CONCEPTOS', seccion: 1, orden: 1006 },
        { documento: 'GRÁFICA DE AVANCE FÍSICO', seccion: 1, orden: 1007 },
        { documento: 'GRÁFICA DE AVANCE FINANCIERO', seccion: 1, orden: 1008 },
        { documento: 'GENERADORES CON CROQUIS Y FOTOGRAFÍAS (SI APLICA)', seccion: 1, orden: 1009 },
        { documento: 'COPIA DE AUTORIZACIÓN DE PRECIOS FUERA DE PRESUPUESTO (SI APLICA)', seccion: 1, orden: 1010 },
        { documento: 'NOTA DE JUSTIFICACIÓN DE OBRA EXCEDENTE (SI APLICA)', seccion: 1, orden: 1011 },
        { documento: 'PRUEBAS DE LABORATORIO / CONTROLES DE CALIDAD (SI APLICA)', seccion: 1, orden: 1012 },
        { documento: 'NOTAS DE BITÁCORA', seccion: 1, orden: 1999 },
        { documento: 'AVISO DE TERMINO', seccion: 2, orden: 2001 },
        { documento: 'BITÁCORA DE OBRA COMPLETA (CERRADA)', seccion: 2, orden: 2002 },
        { documento: 'PLANO DE OBRA TERMINADA (SI APLICA)', seccion: 2, orden: 2003 },
        { documento: 'ACTA DE RECEPCIÓN DE TRABAJOS', seccion: 2, orden: 2004 },
        { documento: 'FINIQUITO', seccion: 2, orden: 2005 },
        { documento: 'ACTA DE ENTREGA (SI APLICA)', seccion: 2, orden: 2006 },
        { documento: 'ACTA DE EXTINCIÓN DE DERECHOS Y OBLIGACIONES (SI APLICA)', seccion: 2, orden: 2999 },
        { documento: 'ENVÍO DE SOPORTE DE ESTIMACIÓN VÍA EMAIL', seccion: 3, orden: 3001 },
        { documento: 'SOLICITUD DE PAGO', seccion: 3, orden: 3002 },
        { documento: 'OFICIO DE SOLICITUD DE TRAMITE PARA PAGO DE ESTIMACIÓN', seccion: 3, orden: 3003 },
        { documento: 'OTRO: ', seccion: 3, orden: 3004 },
        { documento: 'OTRO: ', seccion: 3, orden: 3005 },
        { documento: 'OTRO: ', seccion: 3, orden: 3006 },
        { documento: 'OTRO: ', seccion: 3, orden: 3999 },
      ];
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato,
          estimacion,
          fechaActual,
          listaDocumentos,
          footer: '',
          encabezadoReferencia,
        },
      }, `${contratoEstimacion.numero}_CheckList_${estaEstimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    getPartidas() {
      // Formato de conceptos
      const partidas = this.estimacion.conceptos
        .map(({ concepto: { padre }, concepto }) => {
          let partida = null;
          if (padre.padre && padre.padre.tipo === 0) {
            partida = padre.padre;
          }
          return {
            id: padre.id,
            clave: padre.clave.slice(0, 15),
            concepto: padre.concepto,
            orden: concepto.orden,
            padre: partida,
            tipo: padre.tipo,
            conceptosEstimados: [],
          };
        });

      // Remover conceptos repetidos
      const partidasUnicas = [...new Map(partidas.map((v) => [v.id, v])).values()];

      return partidasUnicas.map((partida) => {
        const conceptos = this.estimacion.conceptos
          .filter(({ concepto: { padre } }) => padre.id === partida.id)
          .map((concepto) => {
            const { estimado } = concepto.concepto;
            const estimadoAnterior = estimado
              .map((con) => ({
                numero: con.estimacion.numero,
                cantidad: con.cantidad,
                importe: con.importe,
              }))
              .filter(({ numero }) => numero < this.estimacion.numero);

            return {
              ...concepto,
              cantidadEstimadaAnterior: this.$ObjSumar(estimadoAnterior, 'cantidad'),
              importeEstimadoAnterior: this.$ObjSumar(estimadoAnterior, 'importe'),
              cantidadEstimadaAcumulada: this.$ObjSumar(estimadoAnterior, 'cantidad') + concepto.cantidad,
              importeEstimadoAcumulado: this.$ObjSumar(estimadoAnterior, 'importe') + concepto.importe,
            };
          })
          .sort((a, b) => a.concepto.orden - b.concepto.orden);

        return {
          ...partida,
          conceptosEstimados: conceptos,
        };
      })
        .sort((a, b) => a.orden - b.orden);
    },
  },
};
